import sagaReducerFactory from 'saga-reducer-factory';
import initActions from '../actions/initActions';
import reservationActions from '../actions/reservationActions';
import organizationActions from '../actions/organizationActions';
import * as I18nActions from '@wix/restaurants-redux/dist/actions/I18nActions';
import {put, take} from 'redux-saga/effects';

const {handle, updateState, saga, reducer} = sagaReducerFactory({
  actionTypes: initActions.types,
  actionCreators: initActions.actions,
  initState: {initialized: false, isMobile: false}
});

handle(initActions.types.REQUEST, function* ({uxMode}, action) {
  const {reservationId, ownerToken, isMobile, restaurantId} = action.payload;
  yield put(updateState({isMobile}));

  // First, get the reservation data
  yield put(reservationActions.actions.getReservationRequest({restaurantId, reservationId, ownerToken}));
  const reservationResponse = yield take(reservationActions.types.GET_RESERVATION_SUCCESS);
  const reservation = reservationResponse.payload;

  // Now, fetch the organization data
  yield put(organizationActions.actions.getOrganizationRequest(reservation.restaurantId));
  const organizationResponse = yield take(organizationActions.types.GET_ORGANIZATION_SUCCESS);

  const organization = organizationResponse.payload;

  // Fetch i18n tokens according to organization locale
  yield put(I18nActions.actions.i18nInit({
    uxMode,
    localeData: {},
    secondarySwitched: false,
    uxLanguage: ''
  }));

  yield put(I18nActions.actions.i18nRequestChange({
    organizationLocale: organization.locale,
    countryCode: organization.address.countryCode
  }));

  yield take(I18nActions.types.I18N_VIEW_READY_FOR_CHANGE);

  yield put(updateState({initialized: true}));
  yield put(initActions.actions.success());
});

export default {saga, reducer};



// WEBPACK FOOTER //
// ./sagas/initSaga.js